import { MINECRAFT_API_URL, DISCORD_API_URL } from '@/config/constants';

export interface MinecraftStats {
  online: boolean;
  players: {
    online: number;
  };
}

export interface DiscordStats {
  presence_count: number;
}

export interface ServerStats {
  playerCount: number;
  discordCount: number;
  isOnline: boolean;
}

export const serverStatsService = {
  async fetchMinecraftStats(): Promise<MinecraftStats | null> {
    try {
      const response = await fetch(MINECRAFT_API_URL);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data: MinecraftStats = await response.json();
      return data;
    } catch (error) {
      console.warn('Failed to fetch Minecraft stats:', error);
      return null;
    }
  },

  async fetchDiscordStats(): Promise<DiscordStats | null> {
    try {
      const response = await fetch(DISCORD_API_URL);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data: DiscordStats = await response.json();
      return data;
    } catch (error) {
      console.warn('Failed to fetch Discord stats (likely CORS):', error);
      return null;
    }
  },

  async fetchServerStats(): Promise<ServerStats> {
    const [minecraftData, discordData] = await Promise.all([
      this.fetchMinecraftStats(),
      this.fetchDiscordStats(),
    ]);

    return {
      playerCount: minecraftData?.online ? minecraftData.players.online : 1247,
      discordCount: discordData?.presence_count || 50234,
      isOnline: minecraftData?.online ?? true,
    };
  },
};
